import React, { useState, useEffect } from 'react';
import '../../App.css';
import { useNavigate } from 'react-router-dom'; 
import { fetchLoanData } from '../../services/api'; 
import { SideMenu, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

function SkipAPay() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [selectedLoan, setSelectedLoan] = useState('');
  const [selectedAccount, setSelectedAccount] = useState('');
  const navigate = useNavigate(); 

  const [isCollapsed, setIsCollapsed] = useState(false);



  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsCollapsed(true);
    } else {
      setIsCollapsed(false);
    }
  };

  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    document.title = 'Skip a Pay | MAX Credit Union';
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const jsonData = await fetchLoanData(); 
        
        setData(jsonData);

        // Ensure data exists before setting defaults
        if (jsonData.LOAN.length > 0) {
          const firstLoan = jsonData.LOAN[0];
          setSelectedLoan(`${firstLoan.LOANID}:${firstLoan.DESCRIPTION}:${firstLoan.DUEDATE}:${firstLoan.MATEDATE}:${firstLoan.AMTDUE}:${firstLoan.FUTDUEDATE}:${firstLoan.FUTMATEDATE}:${firstLoan.LTLOC}`);
        }
        
        // Check if SHARE contains actual share data or just the NOSHARE indicator
        if (Array.isArray(jsonData.SHARE) && jsonData.SHARE.length > 0) {
          // Check if the first item has a NOSHARE property
          if (jsonData.SHARE[0].NOSHARE) {
            navigate('/NoShare');
            return;
          }
          
          // Otherwise, it's a valid share array
          const firstAccount = jsonData.SHARE[0];
          setSelectedAccount(`${firstAccount.SHAREID}:${firstAccount.SHAREDESC}:${firstAccount.SHAREBAL}`);
        }
      } catch (error) {
        setError(error.message);
      }
    }
    fetchData();
  }, [navigate]);

  // Add a new useEffect for handling navigation based on data
  useEffect(() => {
    if (data && data.LOAN.length === 0) {
      navigate('/NoLoan');
    }
  }, [data, navigate]);

  if (error) return <div>Error: {error}</div>;
  if (!data) return <div>Loading...</div>;

  const handleReviewClick = () => {
    navigate('/Review', { state: { selectedLoan, selectedAccount } });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {isCollapsed && <TopMenu />}
      <div style={{ display: 'flex', flex: 1 }}>
        <SideMenu menuItems={menuItems} />
  
        <div style={{ flex: 1, padding: '20px 20px 20px 260px', overflow: 'auto' }}>
          <img src="/SkipAPayHeaders-01.png" alt="Banner Image" />
          <h3><br />Take a month off from your loan payment.</h3>
          <p>With Skip A Pay, you can skip your next monthly payment on any qualifying MAX loan and keep the cash.</p>
          <h3>How it Works:</h3>
          <ul>
            <li>Skip one monthly payment on a qualifying MAX loan once per year.</li>
            <li>Complete the form and pay a $35 fee to schedule your skip.</li>
            <li>Use the extra cash for bills, emergency expenses, holiday shopping, vacations, or any financial need.</li>
          </ul>
          <div className="select-container">
            <select
              id="selected"
              name="selected"
              className="custom-select"
              value={selectedLoan}
              onChange={(e) => setSelectedLoan(e.target.value)}
            >
              {data.LOAN.map((loan) => (
                <option
                  key={loan.LOANID}
                  value={`${loan.LOANID}:${loan.DESCRIPTION}:${loan.DUEDATE}:${loan.MATEDATE}:${loan.AMTDUE}:${loan.FUTDUEDATE}:${loan.FUTMATEDATE}:${loan.LTLOC}`}
                >
                  LN{loan.LOANID} {loan.DESCRIPTION} {loan.DUEDATE}
                </option>
              ))}
            </select>
            <select
              id="payment"
              name="payment"
              className="custom-select"
              value={selectedAccount}
              onChange={(e) => setSelectedAccount(e.target.value)}
            >
              {data.SHARE.map((share) => (
                <option key={share.SHAREID} value={`${share.SHAREID}:${share.SHAREDESC}:${share.SHAREBAL}`}>
                  {share.SHAREID} {share.SHAREDESC} ${parseFloat(share.SHAREBAL.trim()).toFixed(2)}
                </option>
              ))}
            </select>
          </div>
          <button 
            onClick={handleReviewClick}
            style={{
              padding: '10px 20px',
              fontSize: '1.2rem',
              backgroundColor: '#1e3a8a',
              color: 'white',
              border: 'blue',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Review
          </button>
          <h3>Terms & Conditions</h3>
          
        
        <p>Finance Charges, including internet interest, will continue to accrue at the rate provided for in your original loan agreement during the month you skip and after that month. Skipping a payment will extend the term of your loan by one month. You will have to make an extra payment after your loan otherwise would have been paid off and you will be paying a higher total Finance Charge than if you had made your payments as originally scheduled. You will be required to resume your regular monthly payments in the following month you skip a payment. Extension of loan terms does not extend expiration dates of accident, life disability or other insurance.</p>
          
        <p>MAX must receive the certificate before the payment is due. If the account that you have designated from which to deduct the $35.00 Skip-A-Payment fee (MAX checking or MAX primary share account) has insufficient funds to cover the fee, or if your enclosed check is returned, your Skip-A-Payment request will not be processed.</p>
          
        <p>If you have the Gap Insurance on this loan and elect to Skip-A-Payment, it will impact any potential proceeds through the Gap Program. If your payment is set on automatic transfer from another financial institution, or you are using the recurring payment feature myMAX Bill Pay to make your monthly payments on the loan you choose to skip a payment, you are responsible for discontinuing the transfer or the recurring payment on the designated loan. MAX will not be responsible for any non-sufficient check (NSF) return fees charged by other financial institutions, vendors or merchants, which may result from your failure to prevent automatic transfer.</p>
          
        <p>Any loan payment due after the promotion end date is not eligible. MAX reserves the right to revoke the opportunity if your account is delinquent, if you have exceeded our maximum number of extensions, or the certificate is not received within the required time frame.</p>


        </div>
      </div>
      <style type="text/css">
        {`
          .btnwrapper {padding: 20px;}
          .ctr {text-align: center;}
          q2-btn {width: 40%;}
          body {}
          p {font-size: medium; font-weight: normal;}
          h1, h2, h3, h4, h5, h6 {font-size: large; font-weight: bold; color: #3b8ede;}

          .select-container {
              display: flex;
              gap: 10px;
          }

          .custom-select {
              width: 50%; /* Takes up half of the page width */
          }

          /* Responsive image style */
          img {
              max-width: 100%;
              height: auto;
              display: block;
              margin: 0 auto;
          }

          @media screen and (max-width: 768px) {
            div[style*="padding: 20px 20px 20px 260px"] {
              padding: 20px 20px 20px 60px !important;
            }
          }
        `}
      </style>
    </div>
  );
}

export default SkipAPay;
